import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FnolRequest } from "../../models";
import { DataStorageService } from "../../services/data-storage.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'cpf-fnol-request-details-page',
  templateUrl: './fnol-request-details-page.component.html',
  styleUrls: ['./fnol-request-details-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FnolRequestDetailsPageComponent {
  fnolRequest?: FnolRequest;

  constructor(private route: ActivatedRoute,
              private dataStorageService: DataStorageService) {

    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.fnolRequest = this.dataStorageService.fnolRequests.find(fnol => fnol.id === id);
      }
    });
  }

}
